import { z } from "zod";

import { Icon } from "@/client";
import i18n from "@/i18n";

const noDataNavigationItemSchema = z.object({
  icon: z.nativeEnum(Icon),
  title: z
    .string()
    .min(1, { message: i18n.t("validation.navigationTitleRequired") })
    .trim(),
  visibility: z.string().optional(),
});

type NoDataNavigationItemFormData = z.infer<typeof noDataNavigationItemSchema>;

export { noDataNavigationItemSchema };
export type { NoDataNavigationItemFormData };
